import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OtEventListComponent } from './ot-event-list/ot-event-list.component';
import { OtRegistrationSuccessComponent } from './ot-registration-success/ot-registration-success.component';
import { OtRegistrationPriceComponent } from './ot-registration-price/ot-registration-price.component';
import { OtRegistrationPersonComponent } from './ot-registration-person/ot-registration-person.component';
import { OtCityListComponent } from './ot-city-list/ot-city-list.component';
import { OtEventInfoComponent } from './ot-event-info/ot-event-info.component';
import { OtRegistrationSummaryComponent } from './ot-registration-summary/ot-registration-summary.component';
import { OtEventService } from './ot-event.service';
import { SharedModule } from '../shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OtRoutingModule } from './ot-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import {
  NgbAlertModule, NgbTooltipModule, NgbModalModule, NgbTypeaheadModule, NgbDatepickerModule
} from '@ng-bootstrap/ng-bootstrap';
import { NgxCaptchaModule } from 'ngx-captcha';
import { OtBreadcrumbsComponent } from './components/ot-breadcrumbs/ot-breadcrumbs.component';

import { QRCodeModule } from 'angular2-qrcode';
import {
  RegistrationReasonAnswerSelectorComponent
} from './components/registration-reason-answer-selector/registration-reason-answer-selector.component';
import {
  InformationSourceSelectorComponent
} from './components/information-source-selector/information-source-selector.component';

@NgModule({
  declarations: [
    OtEventListComponent,
    OtRegistrationSuccessComponent,
    OtRegistrationPersonComponent,
    OtRegistrationPriceComponent,
    OtCityListComponent,
    OtEventInfoComponent,
    OtRegistrationSummaryComponent,
    OtBreadcrumbsComponent,
    RegistrationReasonAnswerSelectorComponent,
    InformationSourceSelectorComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    OtRoutingModule,
    BrowserModule,
    FormsModule,
    NgbAlertModule,
    NgbTooltipModule,
    NgbModalModule,
    NgbTypeaheadModule,
    NgbDatepickerModule,
    NgxCaptchaModule,
    QRCodeModule,
    FontAwesomeModule
  ],
  providers: [
    OtEventService
  ]
})
export class OtModule { }
